document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('.hero-section-custom__btn--secondary');
  const target = document.getElementById('fitment-guide');

  const getOffset = () => window.innerWidth >= 700 ? 104 : 96;

  const scrollTo = (el) => {
    if (!el) return;
    const dest = el.getBoundingClientRect().top + window.pageYOffset - getOffset();
    const start = window.pageYOffset;
    const dist = dest - start;
    const duration = 800;
    let startT = null;

    const ease = (t, b, c, d) => {
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    };

    const step = (now) => {
      if (!startT) startT = now;
      const elapsed = now - startT;
      window.scrollTo(0, ease(elapsed, start, dist, duration));
      if (elapsed < duration) {
        requestAnimationFrame(step);
      } else {
        window.scrollTo(0, dest);
      }
    };
    requestAnimationFrame(step);
  };

  if (btn) {
    btn.addEventListener('click', (e) => {
      if (target) {
        e.preventDefault();
        scrollTo(target);
      } else {
        e.preventDefault();
        window.location.href = window.location.origin + '/#fitment-guide';
      }
    });
  }

  if (window.location.hash === '#fitment-guide' && target) {
    setTimeout(() => scrollTo(target), 600);
  }
});
